const t = {
  name: "Diagnostics",
  dimensions: { width: 24, height: 24 },
  content: `
<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M13.1978 2L15.8022 2L17.8022 11H22V13H16.1978L14.5 5.35977L10.8022 22H8.19783L6.19783 13H2L2 11H7.80217L9.5 18.6402L13.1978 2Z" fill="currentColor"/>
</svg>
  `
};
export {
  t as Diagnostics
};
